import React, { useState } from 'react';
import { ArrowLeftIcon, CheckIcon } from '@heroicons/react/24/outline';

export default function InStore({ listData, onBack, showToast }) {
  const items = listData?.items?.filter(i => i.itemId) || [];
  const [checked, setChecked] = useState(new Set());

  const toggleItem = (idx) => {
    setChecked(prev => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx);
      else next.add(idx);
      return next;
    });
  };

  const allChecked = checked.size === items.length && items.length > 0;

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <button onClick={onBack} className="p-2 bg-gray-800 rounded-xl hover:bg-gray-700">
          <ArrowLeftIcon className="w-6 h-6" />
        </button>
        <h2 className="text-xl font-bold">In-Store Checklist</h2>
        <span className="text-gray-400 text-sm ml-auto">{checked.size}/{items.length}</span>
      </div>

      <div className="space-y-2">
        {items.map((item, idx) => {
          const done = checked.has(idx);
          return (
            <button
              key={idx}
              onClick={() => toggleItem(idx)}
              className={`w-full text-left px-5 py-4 rounded-xl flex items-center gap-4 border transition-colors ${
                done
                  ? 'bg-gray-800/50 border-gray-700 text-gray-500 line-through'
                  : 'bg-gray-800 border-gray-700 text-white'
              }`}
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                done ? 'bg-green-600' : 'bg-gray-700'
              }`}>
                {done && <CheckIcon className="w-5 h-5 text-white" />}
              </div>
              <div className="flex-1">
                <span className="text-lg font-medium">{item.itemId.friendlyName}</span>
                {item.itemId.variant && <span className="text-gray-400 text-sm ml-2">({item.itemId.variant})</span>}
              </div>
              <span className="text-gray-400 text-lg">×{item.quantity}</span>
            </button>
          );
        })}
      </div>

      {allChecked && (
        <div className="mt-6 text-center">
          <p className="text-green-400 text-lg font-semibold mb-2">✅ All items checked!</p>
          <button onClick={onBack} className="bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-8 rounded-xl text-lg">
            Done — Back to List
          </button>
        </div>
      )}
    </div>
  );
}
